import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-global_icon_mine",
  "use": "icon-global_icon_mine-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-global_icon_mine\"><path d=\"M8 1c3.038 0 5.5 2.453 5.5 5.478a5.483 5.483 0 0 1-3.814 5.216c.965.449 1.665 1.337 2.103 2.664a.489.489 0 0 1-.464.642h-6.65a.489.489 0 0 1-.464-.642c.438-1.327 1.138-2.215 2.102-2.665A5.481 5.481 0 0 1 2.5 6.478C2.5 3.453 4.962 1 8 1Z\" fill-rule=\"nonzero\" stroke=\"#E8E8E8\" stroke-width=\".825\" fill=\"none\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol